// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610162035/js/" + chunkId + "." + {"44":"58d1c272","225":"ed871fdc","481":"7f9bf398","486":"af4dfac6","770":"f1407d62"}[chunkId] + ".0.5269208307736801.chunk.js";
};